export default __webpack_public_path__ + "static/media/telegram-black.fbe16ede.svg";